
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipPassenger as ObiShipPassengerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-passenger.js';
 
 
 

 
 export const ObiShipPassenger = createComponent({
   react: React,
   tagName: 'obi-ship-passenger',
   elementClass: ObiShipPassengerElement,
   events: {
     
   }
  });
 
 